export default [
  {
    id: 'forfeit-email',
    name: 'Forfeit Email',
  },
  {
    id: 'forfeit-sms',
    name: 'Forfeit SMS',
  },
];
